import { Keyboard, NativeModules, Platform } from 'react-native';
import { isIOS } from '../utils/utils';

// Web 端 Toast 实现
let toastContainer: HTMLDivElement | null = null;
let toastTimeout: NodeJS.Timeout | null = null;

const createWebToast = (message: string) => {
  if (Platform.OS !== 'web') {
    return;
  }

  // 创建或获取容器
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.id = 'react-native-toast-container';
    toastContainer.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 9999;
      pointer-events: none;
      display: flex;
      align-items: center;
      justify-content: center;
    `;
    document.body.appendChild(toastContainer);
  }

  // 清除之前的 Toast
  if (toastTimeout) {
    clearTimeout(toastTimeout);
    toastTimeout = null;
  }
  
  // 移除之前的 Toast 元素
  while (toastContainer.firstChild) {
    toastContainer.removeChild(toastContainer.firstChild);
  }

  // 创建 Toast 元素
  const toast = document.createElement('div');
  toast.style.cssText = `
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 12px 24px;
    border-radius: 8px;
    font-size: 14px;
    min-width: 0;
    width: auto;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    animation: toastFadeIn 0.3s ease-out;
    display: inline-block;
  `;
  toast.textContent = message;

  // 添加动画样式（如果还没有）
  if (!document.getElementById('toast-animations')) {
    const style = document.createElement('style');
    style.id = 'toast-animations';
    style.textContent = `
      @keyframes toastFadeIn {
        from {
          opacity: 0;
          transform: translateY(-10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
      @keyframes toastFadeOut {
        from {
          opacity: 1;
          transform: translateY(0);
        }
        to {
          opacity: 0;
          transform: translateY(-10px);
        }
      }
    `;
    document.head.appendChild(style);
  }

  toastContainer.appendChild(toast);

  // 2 秒后自动移除
  toastTimeout = setTimeout(() => {
    if (toast && toastContainer) {
      toast.style.animation = 'toastFadeOut 0.3s ease-out';
      setTimeout(() => {
        if (toastContainer && toast.parentNode === toastContainer) {
          toastContainer.removeChild(toast);
        }
      }, 300);
    }
    toastTimeout = null;
  }, 2000);
};

const showBottomToast = (message: string) => {
  if (Platform.OS === 'web') {
    createWebToast(message);
    return;
  }
  
  // 原生平台使用 NativeModules
  if (isIOS) {
    const { ToastIOSModule } = NativeModules;
    if (ToastIOSModule) {
      ToastIOSModule.show({
        message: message,
        duration: 2,
        position: 'bottom',
      });
    }
  } else {
    const { ReactToast } = NativeModules;
    if (ReactToast) {
      ReactToast.showToast(message);
    }
  }
};

export const showToast = (message: string) => {
  if (Platform.OS === 'web') {
    createWebToast(message);
    return;
  }

  // 原生平台
  Keyboard.dismiss();
  
  if (isIOS) {
    const { ToastIOSModule } = NativeModules;
    if (ToastIOSModule) {
      ToastIOSModule.show({
        message: message,
        duration: 2,
        position: 'center',
      });
    }
  } else {
    const { ReactToast } = NativeModules;
    if (ReactToast) {
      ReactToast.showToast(message);
    }
  }
};